var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.12 10L19.56 2.56C20.15 1.97 20.15 1.02 19.56 0.439998C18.97 -0.140002 18.02 -0.150002 17.44 0.439998L10 7.88L2.56 0.439998C1.98 -0.150002 1.03 -0.150002 0.439998 0.439998C-0.150002 1.03 -0.150002 1.97 0.439998 2.56L7.88 10L0.439998 17.44C-0.150002 18.03 -0.150002 18.98 0.439998 19.56C0.729998 19.85 1.12 20 1.5 20C1.88 20 2.27 19.85 2.56 19.56L10 12.12L17.44 19.56C17.73 19.85 18.12 20 18.5 20C18.88 20 19.27 19.85 19.56 19.56C20.15 18.97 20.15 18.02 19.56 17.44L12.12 10Z",
    fill: "#0F0F0F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXClose);
export default __webpack_public_path__ + "static/media/XClose.1fbd78c8.svg";
export { ForwardRef as ReactComponent };